module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking-responsive/pricing-booking.component.css
// module id = ./src/app/component/pricing-booking-responsive/pricing-booking.component.css
// module chunks = main